import * as React from 'react';
import styled from 'styled-components';
import { ICollapsibleProps } from './Collabsible.types';
import { CollapsibleHeader } from '../CollapsibleHeader';
import { handleOnCollapse } from './Collapsible.logic';
import { getRandomKey } from '../../util/randoms';
import { transitionDuration } from '../../theme/base';
import { GridRelay } from '../Grid';

const CollapsibleContent = styled(GridRelay)`
  transition: height ${transitionDuration} ease-out;
  -moz-transition: height ${transitionDuration} ease-out;
  -ms-transition: height ${transitionDuration} ease-out;
  -o-transition: height ${transitionDuration} ease-out;
  -webkit-transition: height ${transitionDuration} ease-out;
`;

const Collapsible: React.FC<ICollapsibleProps> = (props: ICollapsibleProps) => {
  const {
    className = '',
    open,
    header,
    children,
    onCollapse,
    headerClassName,
    testId,
    grid
  } = props;
  const [openState, setOpenState] = React.useState<boolean>(false);
  const [ref, _] = React.useState<React.RefObject<HTMLDivElement>>(
    React.createRef<HTMLDivElement>()
  );

  React.useEffect(() => {
    setOpenState(open);
  }, [open]);

  return (
    <GridRelay grid={grid} className={className}>
      {header && typeof header === 'string' ? (
        <CollapsibleHeader
          className={headerClassName ?? ''}
          onCollapse={() =>
            handleOnCollapse(openState, setOpenState, onCollapse)
          }
          isCollapsed={openState}
          data-testid={testId || 'collapsible-header'}
        >
          {header}
        </CollapsibleHeader>
      ) : (
        <>{header}</>
      )}
      {open && (
        <CollapsibleContent grid={grid} data-testid="collapsible-content">
          <GridRelay
            id={getRandomKey().toString()}
            data-testid="collapsible-container"
            className="collapsible-container"
            ref={ref}
            grid={grid}
          >
            {children}
          </GridRelay>
        </CollapsibleContent>
      )}
    </GridRelay>
  );
};

export default Collapsible;
